import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button } from "primereact/button";
import { InputTextarea, classNames } from "primereact";
import { Toast } from "primereact/toast";

// ------------------ COMPONENTES DE BASE--------------------------
import { useForm } from "../../../../../../Base/Hooks/useForm";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import Loader from "../../../../../../Base/Components/Loader/Loader";

// ------------------- CONSULTAS A LA API---------------------------
import { EliminarItemIngreso } from "../../../../../../API/Suministros/IngresosMateriales/IngresosMaterialesRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------

const CancelarRequisaDet = ({
  cerrar,
  actualizarIngresosScreen,
  selectedDetalle,
  toast,
  setSelected,
}) => {

  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const { values, handleInputChange } = useForm();


  const cancelarDetalle = async () => {
    const comentarioCancelacion = values?.ComentarioCancelacion || "";
  
    const todosValidos = selectedDetalle.every((detalle) => detalle.IdEstado === 29);
  
    if (todosValidos) {
      const detallesIngreso = selectedDetalle.map((detalle) => ({
        ...detalle[0],
        IdRequisaDet: detalle.IdRequisaDet,
        IdUserCancela: userAuth.IdUser,
        ComentarioCancelacion: comentarioCancelacion,
      }));
  
      const eliminados = await EliminarItemIngreso(detallesIngreso);
  
      if (eliminados[0].ESTADO !== -1) {
        setLoading(true);
        toastShow(toast, "success", "Eliminado", eliminados[0].MENSAJE);
        actualizarIngresosScreen();
        setSelected([]);
        setTimeout(() => {
          cerrar();
          setLoading(false);
        }, 1000);
      } else {
        toastShow(toast, "error", "Error al eliminar", eliminados[0].MENSAJE);
      }
    } else {
      toastShow(toast, "error", "Error", "Existen detalles que ya tienen salidas.");
    }
  
  };
  

  return (
    <div id="Dialog" style={{width:'50vh'}}>
      <Toast ref={toast}/>
      <Loader loading={loading} querySelector={"#Dialog"} />
      <div className="flex">
        <div className="flex gap-3 mt-3">
          <h5 className="m-0">¿Está seguro que desea eliminar este item?</h5>

          <span className=" p-float-label d-flex mt-3">
            <InputTextarea
              id="ComentarioCancelacion"
              name="ComentarioCancelacion"
              value={values?.ComentarioCancelacion}
              onChange={handleInputChange}
              cols={100}
              rows={2}
              className={classNames(" block", "encabezado__contenido")}
              style={{
                width: "100%",
                maxHeight: "3rem",
                maxWidth: "72vh",
                height: "3rem",
              }}
            />
            <label
              id="label_comentario"
              htmlFor="ComentarioCancelacion"
              className={classNames("encabezado__contenido")}
            >
              Comentario Cancelación
            </label>
          </span>
        </div>
      </div>

        <div className="mt-3 d-flex justify-content-end">
          <Button
            icon="pi pi-times"
            label="Cancelar"
            className="p-button-text"
            onClick={() => cerrar(false)}
          />
          <Button
            icon="pi pi-check"
            label="Eliminar"
            className="p-button-text"
            onClick={() => {
              cancelarDetalle();
            }}
          />
        </div>

    </div>
  );
};

export default CancelarRequisaDet;
